/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Message_LabelInputs */

const en_snapshot_history_message_label = /** @type {(inputs: Snapshot_History_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const fr_snapshot_history_message_label = /** @type {(inputs: Snapshot_History_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const de_snapshot_history_message_label = /** @type {(inputs: Snapshot_History_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht`)
};

const it_snapshot_history_message_label = /** @type {(inputs: Snapshot_History_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messaggio`)
};

const ru_snapshot_history_message_label = /** @type {(inputs: Snapshot_History_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сообщение`)
};

const es_snapshot_history_message_label = /** @type {(inputs: Snapshot_History_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensaje`)
};

const zh_cn2_snapshot_history_message_label = /** @type {(inputs: Snapshot_History_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`信息`)
};

const ja_snapshot_history_message_label = /** @type {(inputs: Snapshot_History_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メッセージ`)
};

const hi_snapshot_history_message_label = /** @type {(inputs: Snapshot_History_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संदेश`)
};

const pt_pt2_snapshot_history_message_label = /** @type {(inputs: Snapshot_History_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagem`)
};

/**
* | output |
* | --- |
* | "Message" |
*
* @param {Snapshot_History_Message_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_message_label = /** @type {((inputs?: Snapshot_History_Message_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Message_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snapshot_history_message_label(inputs)
	if (locale === "de") return de_snapshot_history_message_label(inputs)
	if (locale === "it") return it_snapshot_history_message_label(inputs)
	if (locale === "ru") return ru_snapshot_history_message_label(inputs)
	if (locale === "es") return es_snapshot_history_message_label(inputs)
	if (locale === "zh-CN") return zh_cn2_snapshot_history_message_label(inputs)
	if (locale === "ja") return ja_snapshot_history_message_label(inputs)
	if (locale === "hi") return hi_snapshot_history_message_label(inputs)
	if (locale === "pt-PT") return pt_pt2_snapshot_history_message_label(inputs)
	return en_snapshot_history_message_label(inputs)
});